/* Mobile presentation only. Symmetry still fetches/converts the PDP and owns
   variant selection, product-form submission, resize observation and close. */
(() => {
  if (theme.lunyaMobileQuickbuy) return;
  const mobile = window.matchMedia('(max-width: 767.98px)');
  const formTriggers = new WeakMap();
  let active = null;

  const restore = () => {
    if (!active) return;
    const { dialog, container, trigger, block, overflow } = active;
    active = null;
    dialog.close();
    dialog.before(container);
    dialog.remove();
    block.style.paddingBottom = '';
    block.querySelector('.block-inner')?.style.removeProperty('--qb-block-height');
    document.documentElement.style.overflow = overflow;
    trigger.setAttribute('aria-expanded', 'false');
    if (trigger.isConnected) trigger.focus({ preventScroll: true });
  };
  const close = () => {
    if (!active) return;
    const { block, container } = active;
    // Close through Symmetry to cancel observers and preserve lifecycle events.
    theme.quickBuy.currentRequestAbortController?.abort();
    theme.quickBuy.contractDetail(block, true);
    const control = container.querySelector('.close-detail');
    control.setAttribute('tabindex', '-1');
    control.setAttribute('aria-hidden', 'true');
    control.removeEventListener('click', theme.quickBuy.onCloseClick);
  };

  document.addEventListener('on:quickbuy:before-open', evt => {
    if (!mobile.matches || !document.body.matches('.lunya-brand.template-collection')) return;
    const container = evt.target;
    const block = container.closest('.product-block');
    const trigger = block?.querySelector('[data-lunya-mobile-quickbuy]');
    if (!trigger || typeof HTMLDialogElement === 'undefined') return;
    if (active) close();
    const dialog = document.createElement('dialog');
    dialog.className = 'lunya-mobile-quickbuy';
    dialog.setAttribute('aria-label', trigger.getAttribute('aria-label') || trigger.textContent.trim());
    container.before(dialog);
    dialog.appendChild(container);
    active = { dialog, container, trigger, block, overflow: document.documentElement.style.overflow };
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
    dialog.showModal();
    // Before-open fires before Symmetry enables the close control.
    queueMicrotask(() => { if (active?.dialog === dialog) container.querySelector('.close-detail').focus(); });
  });
  document.addEventListener('on:quickbuy:after-close', evt => {
    if (active?.container === evt.target) restore();
  });
  document.addEventListener('on:quickbuy:after-open', evt => {
    if (active?.container === evt.target) {
      const form = evt.target.querySelector('product-form');
      if (form) formTriggers.set(form, active.trigger);
    }
  });
  mobile.addEventListener('change', () => { if (!mobile.matches) close(); });
  document.addEventListener('collection:before-replace', close);
  document.addEventListener('shopify:section:unload', evt => {
    if (active && evt.target.contains(active.block)) close();
  });
  window.addEventListener('pagehide', close);
  theme.lunyaMobileQuickbuyBeforeCart = form => {
    if (!active && !formTriggers.has(form)) return null;
    const trigger = formTriggers.get(form) || active?.trigger;
    close();
    // A previous panel's pending add may succeed after it has closed or after
    // filters removed its card. Never open the cart behind another modal.
    return trigger?.isConnected ? trigger : document.querySelector('[data-lunya-mobile-quickbuy], .cart-link');
  };
  theme.lunyaMobileQuickbuy = typeof HTMLDialogElement !== 'undefined';
})();
